const ru = {
  // Navigation
  home: "Главная",
  products: "Продукты",
  about: "О нас",
  contact: "Контакты",
  
  // Hero Section
  heroTitle: "Loveish",
  heroSlogan: "Почувствуй вкус любви",
  heroDescription: "Откройте для себя нашу премиальную коллекцию сухофруктов, орехов, сладостей, солений и джемов. Сделано с любовью, доставлено с заботой.",
  shopNow: "Купить сейчас",
  learnMore: "Узнать больше",
  
  // Products
  driedFruits: "Сухофрукты",
  driedFruitsDesc: "Высококачественные сухофрукты с натуральной сладостью",
  nuts: "Орехи",
  nutsDesc: "Свежие и питательные орехи для здорового перекуса",
  sweets: "Сладости",
  sweetsDesc: "Традиционные персидские сладости по аутентичным рецептам",
  pickles: "Соления",
  picklesDesc: "Вкусные маринованные овощи и оливки",
  jams: "Джемы",
  jamsDesc: "Домашние джемы с натуральным фруктовым вкусом",
  
  // Product Items
  walnuts: "Грецкие орехи",
  almonds: "Сырой и соленый миндаль",
  pistachios: "Сырые, шафрановые и соленые фисташки",
  peanuts: "Арахис",
  hazelnuts: "Фундук",
  chickpeas: "Нут и изюм",
  
  mangoLeaves: "Листья манго",
  peaches: "Персики",
  plums: "Сливы",
  apple: "Яблоко",
  banana: "Банан",
  strawberries: "Клубника",
  yellowPlums: "Желтые сливы",
  pineapples: "Ананасы",
  figs: "Инжир",
  bukharaPlums: "Бухарские сливы",
  
  gaz: "Газ",
  sohan: "Сохан",
  latifeh: "Латифе",
  kalampeh: "Калампе",
  fasaeiBread: "Хлеб Фасаеи",
  datesArdeh: "Финики и арде",
  iceCream: "Мороженое и фалуде",
  pashmak: "Пашмак Хадж Абдулла",
  
  lyte: "Различные виды лите",
  pearlGarlic: "Жемчужный чеснок",
  olives: "Оливки",
  cultivatedOlives: "Культивированные оливки",
  
  strawberryJam: "Клубничный джем",
  carrotJam: "Морковный джем",
  blackcurrantJam: "Джем из черной смородины",
  honey: "Мед",
  
  // About
  aboutTitle: "О Loveish",
  aboutDescription: "Мы увлечены предоставлением вам лучшего выбора традиционных и современных пищевых продуктов. Наша приверженность качеству и аутентичным вкусам делает каждый кусочек незабываемым опытом.",
  
  // Contact
  contactTitle: "Свяжитесь с нами",
  contactDescription: "Мы хотели бы услышать от вас. Свяжитесь с нами по любым вопросам о наших продуктах.",
  messageSentSuccess: "Спасибо! Ваше сообщение успешно отправлено.",
  messageSentError: "Упс! Что-то пошло не так. Пожалуйста, попробуйте еще раз.",
  
  // Footer
  quickLinks: "Быстрые ссылки",
  followUs: "Следите за нами",
  allRightsReserved: "Все права защищены",
  footerDescription: "Премиум персидские орехи, сухофрукты, традиционные сладости и ремесленные продукты с любовью.",
  customerService: "Обслуживание клиентов",
  faq: "Часто задаваемые вопросы",
  privacyPolicy: "Политика конфиденциальности",
  support: "Поддержка",
  newsletter: "Рассылка",
  newsletterDescription: "Подпишитесь, чтобы получать специальные предложения и обновления",
  enterEmail: "Введите ваш email",
  subscribe: "Подписаться",
  
  // Common
  viewAll: "Посмотреть все",
  addToCart: "В корзину",
  buyNow: "Купить сейчас",
  shoppingCart: "Корзина",
  emptyCart: "Ваша корзина пуста",
  clearCart: "Очистить корзину",
  checkout: "Оформить заказ",
  total: "Итого",
  checkoutSuccess: "Спасибо за ваш заказ! Мы свяжемся с вами в ближайшее время.",
  
  // Cart Page
  cartItems: 'Товары в корзине',
  clearAll: 'Очистить все',
  continueShopping: 'Продолжить покупки',
  orderSummary: 'Итоги заказа',
  freeShippingProgress: 'Прогресс бесплатной доставки',
  subtotal: 'Промежуточный итог',
  shipping: 'Доставка',
  tax: 'Налог',
  calculatedAtCheckout: 'Рассчитывается при оформлении',
  proceedToCheckout: 'Перейти к оформлению',
  havePromoCode: 'Есть промокод?',
  enterCode: 'Введите код',
  apply: 'Применить',
  whyShopWithUs: 'Почему покупать у нас',
  securePayment: '100% Безопасная оплата',
  returnPolicy: '30-дневная политика возврата',
  customerSupport: 'Поддержка 24/7',
  qualityGuaranteed: 'Гарантия премиум качества',
  clearCartConfirm: 'Очистить корзину?',
  clearCartMessage: 'Вы уверены, что хотите удалить все товары из корзины? Это действие нельзя отменить.',
  cancel: 'Отмена',
  itemTotal: 'Всего товаров',
  addMoreForFreeShipping: 'Добавьте еще {amount} для бесплатной доставки!',
  yourCartIsEmpty: 'Ваша корзина пуста',
  emptyCartMessage: 'Похоже, вы еще ничего не добавили. Начните покупки и откройте для себя наши удивительные продукты!',
  startShopping: 'Начать покупки',
  yourCart: 'Ваша корзина',
  
  // Products Page
  ourProducts: "Наши продукты",
  searchProducts: "Поиск продуктов...",
  featuredCategories: "Избранные категории",
  specialGifts: "Особые подарки",
  
  // Auth
  login: "Войти",
  logout: "Выйти",
  profile: "Профиль",
  welcomeBack: 'С возвращением',
  loginToAccount: 'Войдите в свой аккаунт',
  createAccount: 'Создать аккаунт',
  joinLoveish: 'Присоединяйтесь к Loveish сегодня',
  email: 'Эл. почта',
  password: 'Пароль',
  confirmPassword: 'Подтвердите пароль',
  firstName: 'Имя',
  lastName: 'Фамилия',
  enterPassword: 'Введите ваш пароль',
  enterFirstName: 'Введите ваше имя',
  enterLastName: 'Введите вашу фамилию',
  signIn: 'Войти',
  signingIn: 'Вход...',
  creatingAccount: 'Создание аккаунта...',
  forgotPassword: 'Забыли пароль?',
  verificationEmailSent: 'Письмо с подтверждением отправлено!',
  checkEmailToVerify: 'Пожалуйста, проверьте свою электронную почту и нажмите на ссылку подтверждения, чтобы активировать свой аккаунт.',
  emailVerified: 'Email успешно подтвержден!',
  canNowLogin: 'Теперь вы можете войти в свой аккаунт.',
  soldOut: 'РАСПРОДАНО',
  comingSoon: 'Скоро в продаже',
  notifyWhenAvailable: 'Уведомить о поступлении',
  outOfStock: 'Нет в наличии'
};

export default ru;
